import axios from 'axios';

const state = {
  lastUpdated: null,
  data: null,
};

const isTimeToUpdate = () =>
  !state.lastUpdated ||
  state.lastUpdated.getTime() + process.env.WEATHER_UPDATE_INTERVAL_MS <
    Date.now();

export function getWeather() {
  if (isTimeToUpdate() || !state.data) {
    return axios.get('/.netlify/functions/weather').then(({ data }) => {
      state.lastUpdated = new Date();
      state.data = data;
      return data;
    });
  }
  return Promise.resolve(state.data);
}
